import axios from 'axios';

const secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";

let axiosInstance = axios.create({
  baseURL: `${secure}${process.env.VUE_APP_ENDPOINT_SERVICES_PROXY}`,
  timeout: 10000,
});

export const info = (message, trace = null) => {
  return log('info', message, trace);
};

export const warning = (message, trace = null) => {
  return log('warning', message, trace);
};

export const error = (message, trace = null) => {
  return log('error', message, trace);
};

async function log(level, message, trace) {
  if(process.env.VUE_APP_APP_ENV === 'local') console.log(`[${level}] [${message}]`, trace);
  return await axiosInstance.post('/api/services-new/logger/log', {
    app: process.env.VUE_APP_APP_NAME,
    level: level,
    message: message,
    trace: trace
  });
}

export default {info, warning, error};